import React, {Dispatch, SetStateAction} from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';

import {ReactComponent as PlusIcon} from 'assets/svg/plus.svg';
import {Page} from 'components/common/Page';
import {ButtonVariant} from 'components/ui-kit/Button';
import {Icon} from 'components/ui-kit/Icon';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {ROUTE} from 'core/routes';
import {isAdmin$} from 'models/auth';
import {
    OrganizationAccessors as Accessors,
    OrganizationFormattedRow,
    OrganizationRawRow,
} from 'types/profile';
import {handleNil} from 'utils/handleNil';

import {ProfileNavigationTabs} from '../NavigationTabs';
import {Wrapper} from '../styled';

import {BalanceCell, CreateOrganizationButton} from './styled';
import {OrganizationGridTable} from './Table';

export function convertData(
    data: OrganizationRawRow[] | undefined,
    t: TFunction,
    setCurrentOrganization: Dispatch<SetStateAction<OrganizationRawRow | null>>,
): Partial<OrganizationFormattedRow>[] {
    if (!data) {
        return [];
    }

    return data.map((elem) => ({
        [Accessors.taxIdNumber]: handleNil(elem.taxIdNumber),
        [Accessors.legalName]: handleNil(elem.legalName),
        [Accessors.address]: handleNil(elem.address.address),
        [Accessors.email]: handleNil(elem.email),
        [Accessors.phone]: handleNil(elem.phone),
        [Accessors.balance]: handleNil(elem.balance),
        // [Accessors.balance]: handleNil(elem, (value: OrganizationRawRow) => (
        //     <BalanceCell onClick={() => setCurrentOrganization(elem)}>
        //         <span>{value.balance}</span>
        //         <Icon source={PlusIcon} width={14} height={14} />
        //     </BalanceCell>
        // )),
        // [Accessors.actions]: handleNil(elem, () => (
        //     <div style={{display: 'flex', gap: 10}}>
        //         <Icon source={PlusIcon} fillColor="#F54848" width={18} height={18} />
        //         <Icon source={SettingsIcon} fillColor="#000" width={18} height={18} />
        //     </div>
        // )),
    }));
}

const getConfig = (t: TFunction) => [
    {
        id: Accessors.taxIdNumber,
        header: t('pages.profile.organizations.columns.taxIdNumber'),
        width: 100,
    },
    {
        id: Accessors.legalName,
        header: t('pages.profile.organizations.columns.legalName'),
        width: 300,
    },
    {
        id: Accessors.address,
        header: t('pages.profile.organizations.columns.address'),
        width: 300,
    },
    {
        id: Accessors.email,
        header: t('pages.profile.organizations.columns.email'),
        width: 150,
    },
    {
        id: Accessors.phone,
        header: t('pages.profile.organizations.columns.phone'),
        width: 100,
    },
    {
        id: Accessors.balance,
        header: t('pages.profile.organizations.columns.balance'),
        width: 100,
    },
    // {
    //     id: Accessors.actions,
    //     header: t('pages.profile.organizations.columns.actions'),
    //     width: 80,
    // },
];

export const Organizations = () => {
    const {t} = useTranslation();
    const history = useHistory();
    const isAdmin = useStore(isAdmin$);

    const CreateBtn = () => {
        if (!isAdmin) return null;
        return (
            <CreateOrganizationButton
                variant={ButtonVariant.Text}
                onClick={() => history.push(ROUTE.ORGANIZATIONS_CREATE)}
            >
                + {t('pages.profile.organizations.create.createBtn')}
            </CreateOrganizationButton>
        );
    };

    return (
        <Page title={t('pages.profile.title')}>
            <Wrapper>
                <ProfileNavigationTabs headingContent={<CreateBtn />} />
                <ContentContainer>
                    <OrganizationGridTable configFunc={getConfig} dataMapper={convertData} />
                </ContentContainer>
            </Wrapper>
        </Page>
    );
};
